var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"views-UserInfo"},[_c('div',{staticClass:"views-title border"},[_vm._v(_vm._s(_vm.$t("userPage.text197")))]),_c('EditInfo'),_c('BasicInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }